import React from 'react'
import {useNavigate} from 'react-router-dom'
import axios from 'axios';

const DashboardInfoCard = (props) => {
    const { items } = props;
    const navigate = useNavigate();
    
    var image_url = '';
    if(items.biz_logo && !Object.keys(items.biz_logo)) {
        image_url = items.biz_logo;
    } else {
        image_url = `${process.env.PUBLIC_URL}/media/avatars/blank.png`;
    }
    const getBusinessDetails = async() => {
        try {
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('systemAdminToken')
                }
            };
            const api_params = {
                sub_domain: items.biz_app_url,
                user_name: localStorage.getItem("system_username")
            }
            await axios.post(`${process.env.REACT_APP_API_URL}admin/valid-subdomains-permission`, api_params, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    if(res.data.data.businessData.length > 0){
                        localStorage.setItem('sass_id', res.data.data.businessData[0].sass_id);
                        localStorage.setItem('subdomain', res.data.data.businessData[0].biz_app_url);
                        localStorage.setItem('business_name', res.data.data.businessData[0].business_name);
                        localStorage.setItem('business_email', res.data.data.businessData[0].biz_email);

                        navigate(`/system-admin/${items.biz_app_url}/agents`);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } catch (error2) {
            console.error(error2)
        }  
    }

    return (
        <div className="col-md-4">
            <div className="card border">
                <div className="card-body d-flex flex-center flex-column py-9 px-5">
                    <div className="symbol symbol-65px symbol-circle mb-5">
                        <img src={`${image_url}`}  alt="image" />
                    </div>
                    <a href="#" className="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">{items.business_name}</a>
                    <div className="fw-semibold text-gray-500 mb-6">Bizz Id : {items.business_id}</div>
                    <div className="d-flex flex-center flex-wrap mb-5">
                        <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                            <div className="fs-6 fw-bold text-gray-700">$14,560</div>
                            <div className="fw-semibold text-gray-500">Available Balance</div>
                        </div>
                        <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                            <div className="fs-6 fw-bold text-gray-700">400</div>
                            <div className="fw-semibold text-gray-500">No of Agents</div>
                        </div>
                    </div>
                    <button className="btn btn-sm btn-light-primary btn-flex btn-center" data-kt-follow-btn="true" onClick={getBusinessDetails}>
                        <i className="ki-duotone ki-check following fs-3"></i>
                        <i className="ki-duotone ki-plus follow fs-3 d-none"></i>
                        <span className="indicator-label">MANAGE</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
export default DashboardInfoCard